export const EULA_GET_ENDPOINT = '/api/User/get-user-eula';
export const EULA_ACCEPT_ENDPOINT = '/api/User/accept-user-eula';

export const GET_ACCEPTED_USER_EULA = '/api/User/eula-accepted-user-grid';
export const GET_ACCEPTED_USER_EULA_DISTINCT =
  '/api/User/eula-accepted-user-grid/distinct';
export const GET_EULA_FOR_MFA = '/api/User/get-eula-for-mfa';
